import '../httpservices/core/ajax.httpservice.core';

class PatientContactInfoHttpService {

    GetInviteProxyPageInitData() {
        return $.get('Patient/ContactInformation/GetInviteProxyPageInitData');
    }

    GetPatientContactInformation() {
        return $.get('api/ContactInfo/GetPatientContactInformation');
    }

    GetPolicyHolderRelationship() {
        return $.get('api/ContactInfo/PolicyHolderRelationship');
    }

    GetPolicyHolderRelationshipDropDown() {
        return $.get('api/ContactInfo/PolicyHolderRelationshipDropDown');
    }

    //model = ContactInformationModel.cs
    ValidateAndGetChanges(model) {
        return $.post('api/ContactInfo/ValidateAndGetChanges', model);
    }

    //model = ContactInformationModel.cs
    SaveForm(model) {
        return $.post('api/ContactInfo/SavePatientContactInformation', model);
    }

    ValidateAndSaveForm(model) {
        return $.post('api/SaveContactInfo', model);
    }

    GetContentBlocks() {
        return $.get('Patient/ContactInformation/GetContentBlocks');
    }

    GetLanguageAndGender() {
        return $.get('api/ContactInfo/GetLanguageAndGender', { NoBannerOnException: true });
    }

    SaveGender(gender) {
        return $.post('api/ContactInfo/SaveGender', gender);
    }

     SaveLanguage(language){
         return $.post('api/ContactInfo/SaveLanguage', language);
     }
}

export const PatientContactHttpSvc = new PatientContactInfoHttpService();